// in src/MyLayout.js
import { Layout } from "react-admin";

import MyMenu from "../menus/MyMenu";

const MyLayout = (props) => <Layout {...props} menu={MyMenu} />;
export default MyLayout;
